import styled from 'styled-components';
import { COMMENT_LIST_PADDING_PX, THREAD_INDENT_PX } from '../constants/sidebar';
import { GYPSUM } from 'HubStyleTokens/colors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const COMMENT_BUTTON_WIDTH = 116.7;
const CANCEL_BUTTON_WIDTH = 96.63;
const CommentEditorSkeleton = styled.div.withConfig({
  displayName: "MiniCommenterSkeleton__CommentEditorSkeleton",
  componentId: "dhqwyc-0"
})(["height:137px;border-radius:10px;background-color:", ";"], GYPSUM);
const ModuleParentCommentSkeleton = styled.div.withConfig({
  displayName: "MiniCommenterSkeleton__ModuleParentCommentSkeleton",
  componentId: "dhqwyc-1"
})(["height:100px;border-radius:10px;background-color:", ";margin-bottom:", "px;"], GYPSUM, COMMENT_LIST_PADDING_PX);
const ThreadIndent = styled.div.withConfig({
  displayName: "MiniCommenterSkeleton__ThreadIndent",
  componentId: "dhqwyc-2"
})(["margin-left:", "px;"], THREAD_INDENT_PX);
const SkeletonWrapper = styled.div.withConfig({
  displayName: "MiniCommenterSkeleton__SkeletonWrapper",
  componentId: "dhqwyc-3"
})(["padding:", "px;padding-bottom:", "px;"], COMMENT_LIST_PADDING_PX, COMMENT_LIST_PADDING_PX + 1);
const ButtonSkeleton = styled.div.withConfig({
  displayName: "MiniCommenterSkeleton__ButtonSkeleton",
  componentId: "dhqwyc-4"
})(["background-color:", ";height:40px;width:", "px;margin-right:12px;"], GYPSUM, ({
  width
}) => width);
const ButtonsSkeleton = styled.div.withConfig({
  displayName: "MiniCommenterSkeleton__ButtonsSkeleton",
  componentId: "dhqwyc-5"
})(["margin-top:12px;display:flex;"]);
export default function MiniCommenterSkeleton({
  hasModuleParentComment
}) {
  const editorAndButtons = /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(CommentEditorSkeleton, {}), /*#__PURE__*/_jsxs(ButtonsSkeleton, {
      children: [/*#__PURE__*/_jsx(ButtonSkeleton, {
        width: COMMENT_BUTTON_WIDTH
      }), /*#__PURE__*/_jsx(ButtonSkeleton, {
        width: CANCEL_BUTTON_WIDTH
      })]
    })]
  });
  return /*#__PURE__*/_jsx(SkeletonWrapper, {
    children: hasModuleParentComment ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(ModuleParentCommentSkeleton, {}), /*#__PURE__*/_jsx(ThreadIndent, {
        children: editorAndButtons
      })]
    }) : editorAndButtons
  });
}